import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import { materialPropType } from 'types/PDPTypes';
import Currency from 'components/consumer/Currency';
import CreditCardOption, { CC_INITIAL_VALUES } from 'components/consumer/checkout/desktop/components/Payment/components/CreditCardOption';
import { getCardInfo } from 'components/consumer/checkout/utils/card';
import withCheckoutUtils from 'components/consumer/checkout/withCheckoutUtils';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconLock2 from 'components/icons/iconLock2';
import getInstallmentPrice from 'commons/getInstallmentPrice';
import IconPetProtector from 'components/icons/iconPetProtector';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import MaterialThumbnail from '../../MaterialThumbnail';
import Radio from '../../../essentials/Radio';
const Summary = props => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <hr className="border-0 [border-top:1px_solid_#e5e5e5] mt-8 -mx-9 mb-11" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.disabled || $[2] !== props.doPurchase || $[3] !== props.error || $[4] !== props.errorMessage || $[5] !== props.loading || $[6] !== props.upChargeSummary) {
    t1 = props.upChargeSummary && <><div className="flex justify-between"><div className="text-sm">Subtotal</div><div className="text-sm font-bold" data-xc="subtotal-value"><Currency>{props.upChargeSummary.cartSubtotal_diff}</Currency></div></div>{props.upChargeSummary.discount > 0 && <div className="flex justify-between"><div className="text-red text-sm">Discount</div><div className="text-red text-sm font-bold" data-xc="discount-value">- <Currency>{props.upChargeSummary.discount}</Currency></div></div>}<div className="flex justify-between"><div className="text-sm">Tax</div><div className="text-sm font-bold" data-xc="tax-value"><Currency>{props.upChargeSummary.tax}</Currency></div></div><div className="flex justify-between"><div className="text-base font-bold">Total</div><div className="text-base font-bold" data-xc="grand-total-value"><Currency>{props.upChargeSummary.grand_total_diff}</Currency></div></div><div className="mx-0 my-6"><CtaButton block={true} disabled={props.disabled || props.loading} styling="solid-button" color="black" spacing="sm" onClick={props.doPurchase} isLoading={props.loading}><IconLock2 /> Complete purchase</CtaButton>{(props.error || props.errorMessage) && <div className="text-sm font-bold text-red mx-0 my-1 text-center">{props.error || props.errorMessage}</div>}</div></>;
    $[1] = props.disabled;
    $[2] = props.doPurchase;
    $[3] = props.error;
    $[4] = props.errorMessage;
    $[5] = props.loading;
    $[6] = props.upChargeSummary;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div>{t0}{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
Summary.propTypes = {
  disabled: PropTypes.bool,
  doPurchase: PropTypes.func,
  error: PropTypes.string,
  errorMessage: PropTypes.string,
  loading: PropTypes.bool,
  upChargeSummary: PropTypes.shape({
    cartSubtotal_diff: PropTypes.number,
    discount: PropTypes.number,
    grand_total_diff: PropTypes.number,
    tax: PropTypes.number
  })
};
const PDPFabricUpChargeModalUI = ({
  cartImg,
  cartItem,
  checkoutUtilActions,
  errorMessage,
  imgSrc,
  isInSidebarModal = false,
  orderId,
  orderInfo,
  paymentMethods,
  selectedMaterial,
  selectedPlan,
  upChargeSummary,
  updateOrder
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [isNewCC, setIsNewCC] = useState(false);
  const [payment, setPayment] = useState({
    split_payment: false,
    credit_cards: [{
      ...CC_INITIAL_VALUES,
      isBillingAddressSame: false
    }]
  });
  const doPurchase = useCallback(async () => {
    try {
      const method = selectedMethod || paymentMethods?.[0];
      if (!isNewCC && method) {
        let existingCCMethod;
        let affirmMethod;
        let payPalMethod;
        let applePayMethod;
        let pointOfSaleMethod;
        if (method.payment_name === 'Affirm') {
          affirmMethod = {
            domain: window.location.origin,
            url_path: window.location.pathname
          };
        } else if (method.payment_name === 'Credit Card') {
          existingCCMethod = {
            cardType: method.cardType,
            payment_name: method.payment_name,
            payment_token: method.payment_token,
            payment_provider: method.payment_provider
          };
        } else if (method.payment_name === 'PayPal') {
          payPalMethod = {
            payment_name: method.payment_name,
            payment_token: method.payment_token,
            payment_provider: method.payment_provider
          };
        } else if (method.payment_name === 'Apple Pay') {
          applePayMethod = {
            payment_name: method.payment_name,
            payment_token: method.payment_token,
            payment_provider: method.payment_provider
          };
        } else if (method.payment_name === 'Point of Sale') {
          pointOfSaleMethod = {
            payment_name: method.payment_name,
            payment_token: method.payment_token,
            payment_provider: method.payment_provider
          };
        }
        setLoading(true);
        setTimeout(async () => {
          await updateOrder({
            orderId,
            cartItem,
            orderInfo,
            selectedPlan,
            taxTotal: upChargeSummary.tax,
            grandTotal: upChargeSummary.grand_total_diff,
            affirmMethod,
            applePayMethod,
            payPalMethod,
            pointOfSaleMethod,
            existingCCMethod
          });
          setLoading(false);
        }, 100);
      }
    } catch (e) {
      setLoading(false);
    }
  }, [cartItem, isNewCC, orderId, orderInfo, paymentMethods, selectedMethod, selectedPlan, upChargeSummary, updateOrder]);
  const SummaryMemoized = useCallback(disabled => <Summary disabled={disabled} doPurchase={doPurchase} error={error} errorMessage={errorMessage} loading={loading} upChargeSummary={upChargeSummary} />, [doPurchase, error, errorMessage, loading, upChargeSummary]);
  return <div>
      <div className="text-xl font-bold">
        {selectedPlan ? `Add ${selectedPlan.plan_name}` : selectedMaterial ? 'Add premium upholstery' : ''}
      </div>
      <div className="bg-gray-light9 border border-solid border-gray-light7 pt-4 px-4 pb-2.5 mt-2">
        <div className="flex [&_img]:mr-2 [&_span]:text-gray-light2">
          {imgSrc && <div>
              <JBImage src={imgSrc} width={100} />
            </div>}
          {cartImg && <div>{cartImg}</div>}
          <div>
            <div className="text-base font-bold">{cartItem.name}</div>
            <div className="text-xs">
              <span>Qty: {cartItem.quantity}</span>
            </div>
          </div>
        </div>
        {selectedPlan && <div className="flex items-center bg-white border border-solid border-gray-light7 p-[.325rem] [&_svg]:w-10 [&_svg]:mx-2 [&_svg]:my-0">
            <div className="h-12 w-10 p-0 pt-0">
              {selectedPlan.plan_name?.includes('Pet') ? <IconPetProtector /> : <IconProtectionPlan />}
            </div>
            <div className="text-sm font-bold ml-4">
              {selectedPlan.plan_name}
            </div>
          </div>}
        {selectedMaterial && <div className="flex items-center bg-white border border-solid border-gray-light7 p-[.325rem]">
            <div className="h-12 w-10 p-0 pt-0">
              <MaterialThumbnail image={selectedMaterial.image} label={selectedMaterial.label} materialId={selectedMaterial.materialId} upholsteryOptionId={selectedMaterial.upholsteryOptionId} description={selectedMaterial.description} variant="PDPFabricUpChargeModal" />
            </div>
            <div className="text-sm font-bold ml-4">
              {selectedMaterial.label}
            </div>
          </div>}
      </div>

      <div className="mt-8">
        <div className="text-xl font-bold">Payment information</div>
        {paymentMethods && paymentMethods.map(method_0 => <Radio key={method_0?.id} onChange={() => {
        setError(null);
        setIsNewCC(false);
        setSelectedMethod(method_0);
      }} checked={!isNewCC && method_0 === (selectedMethod || paymentMethods[0])}>
              <span className="text-sm font-bold">
                {method_0?.payment_name === 'Affirm' ? getInstallmentPrice({
            price: upChargeSummary.grand_total_diff
          }).installment_price_text : method_0?.payment_name === 'Apple Pay' ? 'Charge to Apple Pay' : method_0?.payment_name === 'PayPal' ? 'Charge to PayPal' : method_0?.payment_name === 'Point of Sale' ? 'Charge to Point of Sale card' : `Charge to card ending in ${method_0?.cardNumber?.slice(-4)}`}
              </span>
            </Radio>)}
        <Radio checked={isNewCC} onChange={() => {
        setError(null);
        setIsNewCC(true);
        setSelectedMethod(null);
      }}>
          <span className="text-sm font-bold">
            {paymentMethods?.[0]?.payment_name === 'Affirm' ? 'Pay with a credit card now' : 'Use a different card'}
          </span>
        </Radio>

        {isNewCC && <div className="PDPFabricUpChargeModalUI__paymentSection-cc">
            <CreditCardOption apartmentFieldPlaceholder="Apartment / suite #" hideBillingAddressCheckbox hideSplitPayment hideSubmitOrder isInSidebarModal={isInSidebarModal} payment={payment} variant="ConvertToOrderModalUI" placeOrderWithCC={(split_payment, credit_cards) => {
          try {
            if (isNewCC) {
              const cc = credit_cards?.[0];
              const card = getCardInfo(cc) || {};
              const newCCMethod = {
                cardType: card.cardType,
                cardNumber: card.cardNumber,
                cardExpirationYear: card.cardExpirationYear,
                cardExpirationMonth: card.cardExpirationMonth,
                cardBillingAddress: cc?.billingAddress
              };
              setLoading(true);
              setTimeout(async () => {
                newCCMethod.braintreeNonce = await checkoutUtilActions.getBraintreeNonce({
                  email_address: orderInfo?.customer?.customer_email,
                  shipping: {
                    first_name: orderInfo?.shipping?.address_first_name,
                    last_name: orderInfo?.shipping?.address_last_name
                  },
                  payment: {
                    credit_cards: [{
                      number: card.cardNumber,
                      expiry: card.expiry,
                      cvc: card.cvc,
                      billingAddress: cc?.billingAddress,
                      isBillingAddressSame: cc?.isBillingAddressSame
                    }]
                  },
                  grandTotal: upChargeSummary.grand_total_diff
                });
                await updateOrder({
                  orderId,
                  cartItem,
                  orderInfo,
                  selectedPlan,
                  taxTotal: upChargeSummary.tax,
                  grandTotal: upChargeSummary.grand_total_diff,
                  newCCMethod
                });
                setLoading(false);
              }, 100);
            }
          } catch (e_0) {
            setLoading(false);
          }
        }} submitBtnRenderer={({
          disabled: disabled_0
        }) => SummaryMemoized(disabled_0)} updateCreditCard={(split_payment_0, credit_cards_0) => setPayment({
          split_payment: split_payment_0,
          credit_cards: credit_cards_0
        })} />
          </div>}
      </div>

      {!isNewCC && <Summary doPurchase={doPurchase} error={error} errorMessage={errorMessage} loading={loading} upChargeSummary={upChargeSummary} />}
    </div>;
};
PDPFabricUpChargeModalUI.propTypes = {
  imgSrc: PropTypes.string,
  cartImg: PropTypes.node,
  orderId: PropTypes.string,
  cartItem: PropTypes.shape({
    name: PropTypes.string,
    quantity: PropTypes.number
  }),
  orderInfo: PropTypes.shape({
    shipping: PropTypes.shape({
      address_first_name: PropTypes.string,
      address_last_name: PropTypes.string
    }),
    customer: PropTypes.shape({
      customer_email: PropTypes.string
    })
  }),
  errorMessage: PropTypes.string,
  selectedMaterial: materialPropType,
  paymentMethods: PropTypes.arrayOf(PropTypes.shape({
    cardType: PropTypes.string,
    cardNumber: PropTypes.string,
    payment_name: PropTypes.string,
    payment_token: PropTypes.string,
    payment_provider: PropTypes.string
  })),
  upChargeSummary: PropTypes.shape({
    cartSubtotal_diff: PropTypes.number,
    discount: PropTypes.number,
    tax: PropTypes.number,
    grand_total_diff: PropTypes.number
  }),
  updateOrder: PropTypes.func,
  checkoutUtilActions: PropTypes.shape({
    getBraintreeNonce: PropTypes.func
  }),
  selectedPlan: PropTypes.shape({
    plan_name: PropTypes.string
  }),
  isInSidebarModal: PropTypes.bool
};
export default withCheckoutUtils(PDPFabricUpChargeModalUI);